// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"graphPlaceholder_placeholderContainer__3NYY6","placeholder-glow":"graphPlaceholder_placeholder-glow__3hh27"};